import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './../reducers';
import fetch from 'isomorphic-fetch';
import {clients} from 'wix-restaurants-js-sdk';
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState, axios) {
  const restClient = clients.createRestClient({timeout: 0});
  const middleware = [thunk.withExtraArgument({axios, fetch, restClient}), sagaMiddleware];
  const store = createStore(rootReducer, initialState, applyMiddleware(...middleware));

  return store;
}

export function createRootSaga(sagas, sagaParams) {
  return function* () {
    yield sagas.map(saga => saga(sagaParams));
  };
}



// WEBPACK FOOTER //
// ./store/configureStore.js